import clip from "@/util/clipboard";

/**
 * 格式化日期 - 将年月日格式化为 YYYY-MM-DD 格式
 * @param {number} year - 年份
 * @param {number} month - 月份
 * @param {number} date - 日期
 * @returns {string} - 格式化后的日期字符串
 */
export function formatDate(year, month, date) {
  return [year, month, date].map(formatNumber).join('-');
}

/**
 * 数字格式化 - 给单位数字前加0
 * @param {number|string} n - 需要格式化的数字
 * @returns {string} - 格式化后的字符串
 */
export function formatNumber(n) {
  n = n.toString();
  return n[1] ? n : '0' + n;
}

/**
 * 时间转化函数 - 将时间戳转换为 YYYY-MM-DD HH:mm:ss 格式
 * @param {number|Date} ndate - 时间戳或Date对象
 * @returns {string} - 格式化后的时间字符串
 */
export function formatTime(ndate) {
  if (!ndate) {
    return "-";
  }
  const date = new Date(ndate);
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var day = date.getDate();
  var hour = date.getHours();
  var minute = date.getMinutes();
  var second = date.getSeconds();

  if (month >= 1 && month <= 9) {
    month = "0" + month;
  }
  if (day >= 0 && day <= 9) {
    day = "0" + day;
  }
  if (hour >= 0 && hour <= 9) {
    hour = "0" + hour;
  }
  if (minute >= 0 && minute <= 9) {
    minute = "0" + minute;
  }
  if (second >= 0 && second <= 9) {
    second = "0" + second;
  }

  var result =
    year +
    "-" +
    month +
    "-" +
    day +
    " " +
    hour +
    ":" +
    minute +
    ":" +
    second;
  return result;
}

/**
 * 数字千分位格式化 - 将数字格式化为千分位显示
 * @param {number|string} num - 需要格式化的数字
 * @returns {string} - 格式化后的字符串
 */
export function toThousands2(num) {
  num = num.toString().replace(/\$|\,/g, "");
  if (isNaN(num)) num = "0";
  var sign = num == (num = Math.abs(num));
  num = Math.floor(num * 100 + 0.50000000001);
  var cents = num % 100;
  num = Math.floor(num / 100).toString();
  if (cents < 10) cents = "0" + cents;
  for (var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++)
    num =
      num.substring(0, num.length - (4 * i + 3)) +
      "," +
      num.substring(num.length - (4 * i + 3));
  return (sign ? "" : "-") + num + "." + cents;
}

/**
 * 复制内容到剪贴板
 * @param {string} text - 需要复制的文本
 * @param {Event} event - 事件对象
 */
export function handleCopy(text, event) {
  clip(text, event);
  console.log('已复制:', text);
}

/**
 * Tab页面移除处理
 * @param {string} targetName - 要移除的页面路径
 * @param {Object} context - Vue组件上下文
 */
export function tabRemove(targetName, context) {
  // 首页不可删除
  if (targetName == "/") {
    return;
  }

  // 将该tab从options里移除
  context.$store.commit("delete_tabs", targetName);

  // 还同时需要处理一种情况当需要移除的页面为当前激活的页面时，将上一个tab页作为激活tab
  if (context.activeIndex === targetName) {
    // 设置当前激活的路由
    if (context.options && context.options.length >= 1) {
      context.$store.commit(
        "set_active_index",
        context.options[context.options.length - 1].route
      );
      context.$router.push({ path: context.activeIndex });
    } else {
      context.$router.push({ path: "/welcome" });
    }
  }
}

/**
 * 验证手机号格式
 * @param {string} phone - 手机号
 * @returns {boolean} - 是否为有效格式
 */
export function validatePhone(phone) {
  return /^1[0-9]{10}$/.test(phone);
}

/**
 * 验证是否为正整数
 * @param {string|number} num - 数字
 * @returns {boolean} - 是否为正整数
 */
export function isPositiveInteger(num) {
  return /^[0-9]*[1-9][0-9]*$/.test(num.toString());
}

/**
 * 数组安全获取第一个元素
 * @param {Array} arr - 数组
 * @param {string} key - 要获取的属性名
 * @returns {any|null} - 第一个元素的指定属性值或null
 */
export function safeGetFirst(arr, key = null) {
  if (!Array.isArray(arr) || arr.length === 0) {
    return null;
  }
  return key ? arr[0][key] : arr[0];
}



// WEBPACK FOOTER //
// ./src/views/workOrder/visitRepairUtils/index.js